import { useEffect, useRef } from "react"
import { getLiveSocket } from "./liveSocket"

export function useHelpLive(onEvent) {
  const handlerRef = useRef(onEvent)
  handlerRef.current = onEvent

  useEffect(() => {
    const socket = getLiveSocket()
    if (!socket) return undefined
    const listener = (payload) => {
      if (payload && handlerRef.current) handlerRef.current(payload)
    }
    socket.on("help-message", listener)
    return () => socket.off("help-message", listener)
  }, [])
}
